// loader.interceptor.ts
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from '../loader.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-loading',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  loading = new BehaviorSubject<boolean>(false);

  constructor(
    public loaderService: LoaderService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loaderService.loading.subscribe((isLoading) => {
      this.loading.next(isLoading);
      this.changeDetector.detectChanges();
    });
  }
}
